<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-bluetooth-off`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.615 2.787l39.598 39.598a1 1 0 010 1.414L43.8 45.213a1 1 0 01-1.414 0L2.787 5.615a1 1 0 010-1.414L4.2 2.787a1 1 0 011.414 0zm13.113 23.011l6.54 6.541v2.925l1.649-1.276 3.23 3.23-7.175 6.32a1 1 0 01-1.66-.751V28.868l-5.8 5.913a1 1 0 01-1.415.013l-.013-.013-1.397-1.424a1 1 0 010-1.4l6.04-6.159zM22.31 4.213a1 1 0 01.661.25l12.142 10.69a1 1 0 01-.03 1.527l-6.25 5.084-3.04-3.04 3.61-2.79-4.136-3.198v5.461L21.31 14.24V5.213a1 1 0 011-1z"/></svg>
</template>
<script>

export default {
  name: 'IconBluetoothOff',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
